"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOT_LOCATION_ID = exports.REMOTE = exports.ABROAD = void 0;
exports.ABROAD = 'ABROAD';
exports.REMOTE = 'REMOTE';
exports.ROOT_LOCATION_ID = 1;
